module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Angi Morgan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v(" "), _c('Br', [_c('Br', [_vm._v("Using actual Texas settings and realistic characters, this "), _c('I', [_vm._v("USA Today")]), _vm._v(" and "), _c('I', [_vm._v("Publisher's Weekly")]), _vm._v(" bestseller, creates stories with characters who put everything on the line. Angi is an 11th generation Texan who lives there with her husband and 'four-legged' kids. Find her at AngiMorganAuthor.com")], 1)], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/19JBosH/tc-custom/9781488033049.jpg?1705346902807",
      "alt": "This image is the cover for the book Ranger Protector, Texas Brothers of Company B"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ranger Protector, Texas Brothers of Company B\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The "), _c('i', [_vm._v("USA Today")]), _vm._v("–bestselling author kicks off her new series with an addictive tale of crime and passion—Texas Ranger style!")]), _c('br'), _c('br'), _vm._v("All Texas Ranger Jack MacKinnon has to do is keep Megan Harper alive while they hunt down whoever’s framing her for a fatal shooting. But the gorgeous intelligence analyst is too independent for her own good—and Jack’s peace of mind."), _c('br'), _c('br'), _vm._v("With a false murder rap and hit men gunning for her, Megan has no choice but to trust the cowboy-handsome lawman. She isn’t used to playing it safe. Yet how can she let Jack put his career and life on the line? And how can they ignore the desire ratcheting up the stakes, tempting them to take one last risk before a killer erases their future?"), _c('br'), _c('br'), _c('b', [_vm._v("“A fast-paced, explosive, lively story with humorous banter and intriguing characters who have chemistry in spades.” —"), _c('i', [_vm._v("Books & Spoons")])]), _c('br'), _c('br'), _c('b', [_vm._v("“Angi Morgan kicks off her brand new series Texas Brothers of Company B in grand style! . . . the rare romantic suspense where the romance feels real.” —"), _c('i', [_vm._v("Fresh Fiction")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0